import React from 'react';
import './styles/Home.css';
import Main from '../Home/Main';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import NavBar from "../Shell/NavBar";
import GuscioNova from "../Nova/GuscioNova";
import {ascoltaSkin} from '../../skin';
import {testata} from '../../moduli/leggi';

class Home extends React.Component {
    /* Il rinnovo del gettone NON sta piu' qui. Il vecchio orologio provava
       a rinnovare DOPO che il rinnovo era gia' scaduto, ogni cinque minuti:
       cioe' sempre tardi. Adesso lo fa il custode della sessione
       (services/sessione.js), prima della scadenza e solo se la persona ha
       fatto qualcosa, con i tempi che manda il server. */
    componentDidMount() {
        const { userService } = this.props;
        if (userService.initProfileIfLoggedIn) userService.initProfileIfLoggedIn();
        /* Quando la skin cambia (in anteprima, a ogni ritocco nel
           backoffice) si ridisegna tutto il guscio: testata, pagine, piede,
           barra. I componenti a funzione hanno useSkin(); quelli a classe
           (Main, SportContainer) si ridisegnano perche' si ridisegna questo. */
        this.staccaSkin = ascoltaSkin(() => this.forceUpdate());
    }

    componentWillUnmount() {
        if (this.staccaSkin) this.staccaSkin();
    }

    render() {
        const { history, userService } = this.props;
        /* LO STILE LO SCEGLIE LA SKIN (modulo Testata › forma › stile): con
           «nova» testata, menu, barra in basso e piede sono quelli di Nova
           (components/Nova); di serie resta il guscio di sempre. */
        if (testata().stile === 'nova') {
            return (
                <GuscioNova userService={userService}>
                    <Main
                        history={history}
                        userService={userService}
                    />
                </GuscioNova>
            );
        }
        return (
            <div className="main-containers">
                <Header
                    history={history}
                    name="Header"
                    userService={userService}/>

                <Main
                    history={history}
                    userService={userService}
                />

                <Footer
                    history={history}
                    name="Footer"
                    userService={userService}/>

                <NavBar userService={userService}/>
            </div>
        );
    }
}

export default Home;
